import { render } from "./SegmentProposalModal.vue?vue&type=template&id=99acb2da"
import script from "./SegmentProposalModal.vue?vue&type=script&lang=js"
export * from "./SegmentProposalModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/pathways/SegmentProposalModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "99acb2da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('99acb2da', __exports__)) {
    api.reload('99acb2da', __exports__)
  }
  
  module.hot.accept("./SegmentProposalModal.vue?vue&type=template&id=99acb2da", () => {
    api.rerender('99acb2da', render)
  })

}


export default __exports__